export default "__VITE_PUBLIC_ASSET__10ee8818__"